import { createSelector as ormCreateSelector } from 'redux-orm';
import orm from 'model';
import { PZ_BUSINESS_ROLES_ENABLED } from 'consts';

/**
 * Get all config values for a specific FSP
 * @param {number} fspId - The FSP ID
 * @returns {Function} Selector function
 */
export const fspConfigValuesSelector = (fspId) =>
  ormCreateSelector(orm, (session) => {
    return session.FspConfigValues.filter({ fspId }).toRefArray();
  });

/**
 * Get specific config value by key
 * @param {number} fspId - The FSP ID
 * @param {string} configKey - The config key to find
 * @returns {Function} Selector function
 */
export const configValueByKeySelector = (fspId, configKey) =>
  ormCreateSelector(orm, (session) => {
    const configValues = session.FspConfigValues.filter({ fspId }).toRefArray();
    return configValues.find((cv) => cv.valueItem?.configKey === configKey);
  });

/**
 * Get Business Roles Enabled value
 * @param {number} fspId - The FSP ID
 * @returns {Function} Selector function
 */
export const businessRolesEnabledSelector = (fspId) =>
  ormCreateSelector(orm, (session) => {
    const configValues = session.FspConfigValues.filter({ fspId }).toRefArray();
    const businessConfig = configValues.find(
      (cv) => cv.valueItem?.configKey === PZ_BUSINESS_ROLES_ENABLED
    );
    return businessConfig?.valueItem?.configValue === '1';
  });
